import type { ISitemapResponse } from '~/interfaces/dto/sitemap/response';
import { useSiteStore } from '~/stores/site.store';
import { remapSitemap } from '~/utilities/sitemap-mapper';

export const useSitemapService = () => {
  const { $fetch } = useNuxtApp();
  const settings = useSiteStore();

  const fetchSitemap = async (countryCode: string) => {
    return await $fetch<{ siteMaps: ISitemapResponse[] }>(
      `cron/sitemaps/jackpotcity/${countryCode}`,
      {
        base: 'config',
        retry: false,
        keepalive: true,
        onResponse({ response }) {
          try {
            const sitemap = remapSitemap(response._data.siteMaps[0]?.sitemap);
            settings.setSiteMap(sitemap);
            settings.setSitemapHost(
              response._data.siteMaps[0]?.request?.host.replace(
                /(.dv|.stg)/,
                '',
              ),
            );
          } catch (e) {
            console.error(e);
          }
        },
        onRequestError(context) {
          console.error('[REQUEST ERROR]:', context);
          showError({
            statusCode: 500,
            statusMessage: 'Could not load site pages',
            fatal: true,
          });
        },
        onResponseError(context) {
          console.error('[RESPONSE ERROR]:', context);
        },
      },
    ).catch((e) => {
      console.error(e);
    });
  };

  return { fetchSitemap };
};
